/**
 * @module Popup
 */

import '../../../scripts/animate';
/* Полифилл matches() для работы wicg-inert в IE. */
import '../../../scripts/matchesPolyfill';
import 'wicg-inert';
import { getKeyName } from '../../../scripts/helpers';
import Component from '../Component';
import './styles.css';

/**
 * Попап.
 *
 * @todo Не работает анимация открытия правого попапа, в IE оба боковых.
 * @todo У дочерних попапов дублируется скроллбар.
 * @todo Нет возможности отключить анимацию при переходе между попапами.
 */
export default class Popup extends Component {
    static className = 'popup';

    static keyCodes = {
        ESC: 27,
    };

    initElements() {
        this.elements = {
            $overlay: $('.popup__overlay', this.$block),
            $wrapper: $('.popup__wrapper', this.$block),
            $inner: $('.popup__inner', this.$block),
            $close: $('.popup__close', this.$block),
        };
    }

    setTemplateProperties() {
        /**
         * Флаг включения оверлея.
         * @type {boolean}
         */
        this.overlay = Boolean(this.elements.$overlay.length);
    }

    setProperties({
        animationOpen = 'zoomIn',
        animationClose = 'zoomOut',
        animationTime = 400,
        breakpointHide,
        showParentAfterClose = false,
    }) {
        /**
         * Анимация открытия.
         * @type {string}
         */
        this.animationOpen = animationOpen;

        /**
         * Анимация скрытия.
         * @type {string}
         */
        this.animationClose = animationClose;

        /**
         * Время анимации.
         * @type {number}
         */
        this.animationTime = animationTime;

        /**
         * Ширина экрана, на которой попап скрывается.
         * @type {MediaQueryList}
         */
        this.breakpointHide = breakpointHide ? window.matchMedia(`(max-width: ${breakpointHide - 1}px)`) : null;

        /**
         * Флаг необходимости открытия родительского попапа после закрытия текущего.
         * @type {boolean}
         */
        this.showParentAfterClose = showParentAfterClose;

        /**
         * Родительский попап.
         * @type {Popup}
         */
        this.parentPopup = null;

        /**
         * Соответствие медиазапросу на скрытие попапа.
         * @type {boolean}
         */
        this.isMatches = null;

        if (this.breakpointHide) {
            this.isMatches = this.breakpointHide.matches;
        }

        /**
         * Список функций, который нужно будет выполнить после открытия конкретного popup
         */
        this.afterOpenHandlers = [];
    }

    /**
     * Открывает попап.
     *
     * @param {boolean} [parent = false] Режим родительского попапа.
     */
    open(parent = false) {
        if (!parent) {
            /**
             * Активный элемент (в фокусе) перед открытием попапа.
             * @type {jQuery}
             */
            this.previousActiveElement = document.activeElement;
        }

        /* Всем прямым наследникам body кроме попапов проставляется inert через полифилл wicg-inert. Это позволяет заблокировать табуляцию на всех элементах кроме открытого попапа. */
        Array.from(document.body.children).forEach(child => {
            /* wicg-inert использует contains(), который не работает в IE с svg, поэтому идёт дополнительная проверка на svg. svg - это спрайт, и отстутствие у него inert ни на что не влияет. */
            if (!$(child).hasClass('popup') && child.tagName !== 'svg') {
                child.inert = true;
            }
        });

        this.$block.addClass('is-open');

        if (this.animationOpen) {
            this.elements.$overlay.css('animation-duration', `${this.animationTime}ms`).animateCss('fadeIn');
            this.elements.$inner
                .css('animation-duration', `${this.animationTime}ms`)
                .animateCss(this.animationOpen, this.afterShow);
        }

        $('html').addClass('popup-lock');

        this.calcWrapperHeight();

        /* При открытии попапа фокус переносится с активного элемента страницы на кнопку закрытия попапа. */
        this.elements.$close[0].focus();

        /**
         * Метод после открытия
         * В обработчик передаем текущий экземпляр попапа
         */
        this.afterOpenHandlers.forEach(handler => handler(this));
    }

    /**
     * Закрывает попап.
     *
     * @param {jQuery} [$focusElem] Элемент для фокуса после закрытия (без него вернётся на сохранённый).
     * @param {boolean} [parent = false] Режим родительского попапа.
     */
    close($focusElem, parent = false) {
        /**
         * Действия после закрытия попапа.
         */
        const onPopupClose = () => {
            this.$block.removeClass('is-open');
            this.elements.$wrapper.height('');

            /* Если в попапе есть видео с youtube, ставим его на паузу */
            if (this.$block.find('iframe').length > 0) {
                const $iframe = this.$block.find('iframe');
                $iframe.each((i, item) => {
                    item.contentWindow.postMessage(
                        JSON.stringify({
                            event: 'command',
                            func: 'pauseVideo',
                            args: '',
                        }),
                        '*'
                    );
                });
            }

            $('html')
                .removeClass('popup-lock')
                .height('');

            if (this.parentPopup && this.showParentAfterClose) {
                this.parentPopup.open(true);
                /* После закрытия очищаем parentPopup, т.к. этот попап может быть использован в других местах не как дочерний. Так что присвоение ссылки на родителя должно происходить только по факту вызова. */
                this.parentPopup = null;
            }

            if (!parent) {
                /* После закрытия всех попапов inert отключается. */
                if (!$('.popup.is-open').length) {
                    Array.from(document.body.children).forEach(child => {
                        if (!$(child).hasClass('popup') && child.tagName !== 'svg') {
                            child.inert = false;
                        }
                    });
                }

                /* Возвращаем фокус на ранее сохранённый активный элемент, если элемент для фокуса не передан напрямую. */
                if (!$focusElem) {
                    this.previousActiveElement.focus();
                } else {
                    $focusElem[0].focus();
                }
            }
        };

        if (this.animationClose) {
            this.elements.$overlay.animateCss('fadeOut');
            this.elements.$inner.animateCss(this.animationClose, onPopupClose);
        } else {
            onPopupClose();
        }
    }

    /**
     * Вычисляет высоту попапа.
     */
    calcWrapperHeight() {
        const innerHeight = this.elements.$inner.height();
        this.elements.$wrapper.height(innerHeight);
        $('html').height(innerHeight);
    }

    /**
     * Обработчик открытия попапа.
     *
     * @param {Function} — функция-обработчик открытия popup
     */
    afterOpen(handler) {
        this.afterOpenHandlers.push(handler);
    }

    /**
     * Обработчик завершения анимации открытия попапа.
     */
    afterShow() {}
}

$(document).on('click', '[data-popup="open"]', handleOpenBtnClick);
$(document).on('click', '[data-popup="close"]', handleCloseBtnClick);
$(document).on('mousedown', '.popup__wrapper', handlePopupWrapperClick);
$(document).on('keydown', '.popup', handlePopupKeydown);
$(window).on('resize', handlePopupResize);

function handleOpenBtnClick(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $($target.attr('data-href'));
    const popup = Popup.getInstance($block);

    const $parent = $target.closest('.popup');

    if ($parent.length) {
        if (!popup.parentPopup) {
            const parentPopup = Popup.getInstance($(`#${$parent.attr('id')}`));
            popup.parentPopup = parentPopup;
        }

        popup.parentPopup.close(undefined, true);

        setTimeout(() => {
            popup.open();
        }, popup.parentPopup.animationTime);
    } else {
        popup.open();

        /**
         * Для попапа с видео.
         */

        if (typeof $target.attr('data-video-src') !== typeof undefined && $target.attr('data-video-src') !== false) {
            const $iframe = $block.find('iframe');
            const src = `${$target.attr('data-video-src')}?enablejsapi=1`;

            if (typeof $iframe.attr('src') == typeof undefined || $iframe.attr('src') == false) {
                $iframe.attr('src', src);
            }
        }
    }
}

function handleCloseBtnClick(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $($target.attr('data-href'));
    const popup = Popup.getInstance($block);

    popup.close();
}

function handlePopupWrapperClick(e) {
    const { target } = e;
    const $target = $(target);

    if ($target.closest('.popup__inner').length || $target.is('.popup__inner')) return;

    const $block = $target.closest('.popup');
    const popup = Popup.getInstance($block);

    popup.close();
}

function handlePopupKeydown(e) {
    const { currentTarget, keyCode } = e;
    const $target = $(currentTarget);
    const key = getKeyName(Popup.keyCodes, keyCode);

    if (!key) return;

    const $block = $target.closest('.popup');
    const popup = Popup.getInstance($block);

    popup.close();
}

function handlePopupResize() {
    const $block = $('.popup.is-open');

    if (!$block.length) return;

    const popup = Popup.getInstance($block);

    popup.calcWrapperHeight();

    if (popup.breakpointHide) {
        /* Эта переменная отображает статус соответствия на текущем ресайзе, а в объекте хранится статус до ресайза. */
        const isMatches = popup.breakpointHide.matches;

        /* Если произошёл переход через брейкпоинт, то закрываем попап. */
        if ((isMatches && !popup.isMatches) || (!isMatches && popup.isMatches)) {
            popup.close();
        }

        /* И обновляем статус объекта. */
        popup.isMatches = isMatches;
    }
}
